import { useThemeStatusStore } from 'store/themeStatus.store';

import classes from 'components/common/ColorTextByValue/ColorTextByValue.module.scss';

import { getTitleColorByStatus } from 'components/widgets/ProjectSummary/components/CardsSection/components/ProgressCard/ProgressCard.utils';

export const ColorTextByValue = ({ value, className }: { value: number; className?: string }) => {
    const { themeStatus } = useThemeStatusStore();
    const color = getTitleColorByStatus({ value, theme: themeStatus });
    return (
        <span style={{ color }} className={`${classes.container} ${className ?? ''}`}>
            {value}
        </span>
    );
};
